export const hu = {
  returnLineItems: {
    refund: "Visszatérítés(ek)",
    exchange: "Csere/cserék",
    newOrder: "Új rendelés",
    discount: "Kedvezmény(ek)",
  },
  returnStoreAddress: {
    mapButton: "Megtekintés a térképen",
  },
  downloadLabel: {
    label: "Címke letöltése",
    bonDeRetour: "Visszaküldési bizonylat letöltése",
  },
  returnRequestDate: {
    label: "A visszaküldési kérelmét {{date}} {{time}} időpontban adta le",
  },
  actions: {
    continue: "Folytatás",
  },
  "order-identification": {
    title: "Kövesse nyomon rendelését",
    description: "Adja meg a rendelési adatokat a csomag követéséhez",
    fields: {
      "zip-code": {
        title: "Irányítószám",
        description: "Adja meg a szállítási irányítószámot",
        required: "Az irányítószám megadása kötelező",
      },
      email: {
        title: "E-mail cím",
        description: "Adja meg a rendeléshez használt e-mail címét",
        required: "Az e-mail cím megadása kötelező",
      },
      both: {
        title: "Irányítószám vagy e-mail",
        description: "Adja meg a szállítási irányítószámát vagy a rendeléséhez használt e-mailt",
        required: "Az irányítószám vagy az e-mail megadása kötelező",
      },
      "tracking-number": {
        title: "Rendelésszám",
        description: "Adja meg a rendelésszámát",
        required: "A rendelésszám megadása kötelező",
      },
    },
    errors: {
      "unknown-order": {
        title: "Ismeretlen rendelésszám",
        description: "A rendelésszám nem található, kérjük ellenőrizze",
      },
      "search-error": {
        title: "Keresési hiba",
        description:
          "Nem sikerült megtalálni a rendelést. Kérjük, próbálja később.",
      },
    },
  },
  delivery: "Szállítás",
  "parcel-history": "Csomag előzmények",
  "order-details": {
    title: "Rendelés részletei",
    "tracking-number": "Nyomkövetési szám",
    "order-number": "Rendelésszám",
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "Becsült kézbesítési dátum",
      deliveredOn: "Kézbesítve",
      from: "tól",
      to: "ig",
    },
  },
  deliveryAddress: {
    title: "Szállítási cím:",
    titlePickup: "Átvételi pont címe:",
    orderDetails: {
      title: "Rendelés részletei:",
      trackingNumber: "Követési szám:",
      orderNumber: "Rendelésszám:",
      orderDate: "Rendelés dátuma:",
    },
  },
  pickupPoint: {
    title: "Átvételi pont",
    openingHours: "Nyitvatartás:",
    closed: "Zárva",
    directions: "Útvonal",
    days: {
      monday: "Hétfő:",
      tuesday: "Kedd:",
      wednesday: "Szerda:",
      thursday: "Csütörtök:",
      friday: "Péntek:",
      saturday: "Szombat:",
      sunday: "Vasárnap:",
    },
  },
  wallet: {
    warningNotEnabled: "Engedélyeznie kell a Wallet-et a bolt beállításaiban",
  },
  crossSell: {
    youMightAlsoLike: "Ezek is tetszhetnek",
  },
  "rate-order": {
    "order-recap": {
      title: "Az Ön rendelése",
      "tracking-label": "Követési szám:",
      "order-label": "Rendelésszám:",
    },
    form: {
      title: "Értékelje a kézbesítést",
      "rating-label": "Értékelje a kézbesítési élményt",
      "comment-label": "Megjegyzés (nem kötelező)",
      "comment-placeholder": "Ossza meg velünk a tapasztalatát…",
      "submit-cta": "Értékelés elküldése",
      "update-cta": "Értékelés frissítése",
      "rating-required": "Kérjük, válasszon egy értékelést.",
    },
    "thank-you": {
      title: "Köszönjük a visszajelzést!",
      description:
        "Értékelését elmentettük. Segíteni fog a kézbesítési élmény javításában.",
    },
    errors: {
      "invalid-token": {
        title: "Érvénytelen vagy lejárt link",
        description:
          "Ez a link már nem érvényes. Kérjük, nyissa meg újra a legutóbbi követési e-mailjéből.",
      },
      submit: {
        title: "Valami hiba történt",
        description:
          "Nem tudtuk elmenteni az értékelését. Kérjük, próbálja később újra.",
      },
    },
  },
  shippingInstructions: {
    colissimo: "Most kinyomtathatod a visszaküldési címkét, és leadhatod a csomagot a legközelebbi Colissimo átvevőponton.",
    chronoShop2Shop: "Most kinyomtathatod a visszaküldési címkét, és leadhatod a csomagot a legközelebbi Chronopost átvevőponton.",
    ups: "Most kinyomtathatod a visszaküldési címkét, és leadhatod a csomagot a legközelebbi UPS átvevőponton.",
    customerCarrier: "Most elküldheted a visszaküldendő csomagot az általad választott futárszolgálattal.",
    merchantCarrier: "1–3 munkanapon belül e-mailben elküldjük a visszaküldési címkét.",
    returnToStore: "Most leadhatod a csomagot a legközelebbi üzletben.",
    malca: "Most kinyomtathatod a visszaküldési címkét, és leadhatod a csomagot a legközelebbi Malca átvevőponton.",
    tnt: "Most kinyomtathatod a visszaküldési címkét, és leadhatod a csomagot a legközelebbi TNT átvevőponton.",
    bonDeRetour: "A visszaküldési bizonylatod elkészült. Most kinyomtathatod és felhasználhatod a visszaküldéshez.",
    unknownCarrier:
      "Most már kinyomtathatja a visszaküldési címkét, és feladhatja csomagját a címkén feltüntetett fuvarozóval.",
  },
  shippingInstructionsTitle: {
    shippingLabel: "A szállítási címkéd elkészült",
    bonDeRetour: "A visszaküldési bizonylatod elkészült",
  },
} as const;
